import { mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from './../../services/modules';
import organizationSettingsService from './../../services/organizationSettings';

export default {
  props: {
    mod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new Forms({
        poweroffice_client_key: { type: 'text', value: '' },
        poweroffice_company_slug: { type: 'text', value: '' },
        poweroffice_integration_type: { type: 'select', value: '' },
      }),

      loading: false,
    };
  },

  mounted() {
    this.loading = true;

    Promise.all([
      this.loadSettings(),
    ]).finally(() => {
      this.loading = false;
    });
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Load existing PowerOffice settings
     * (camelCase + snake_case safe, UniMicro-style)
     */
    loadSettings() {
      return organizationSettingsService
        .show()
        .then((settings) => {
          console.log('[PowerOffice] Raw organization settings:', settings);

          settings = settings || {};

          const norm = (obj, key) => {
            if (obj[key] !== undefined && obj[key] !== null) {
              return obj[key];
            }
            const snake = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            if (obj[snake] !== undefined && obj[snake] !== null) {
              return obj[snake];
            }
            return '';
          };

          /*
          |----------------------------------------------------------------------
          | Normalize values
          |----------------------------------------------------------------------
          */
          const clientKey = norm(settings, 'powerofficeClientKey');
          const companySlug = norm(settings, 'powerofficeCompanySlug');
          const appKey = norm(settings, 'powerofficeAppKey');
          const integrationType = norm(settings, 'powerofficeIntegrationType');

          console.log('[PowerOffice] Normalized values:', {
            powerofficeClientKey: clientKey,
            powerofficeCompanySlug: companySlug,
            powerofficeAppKey: appKey,
            powerofficeIntegrationType: integrationType,
          });

        /*
        |----------------------------------------------------------------------
        | Assign to form (SAFE — handles string + object fields)
        |----------------------------------------------------------------------
        */
        if (typeof this.form.set === 'function') {
        this.form.set('poweroffice_client_key', String(clientKey).trim());
        this.form.set('poweroffice_company_slug', String(companySlug).trim());
        this.form.set('poweroffice_integration_type', String(integrationType).trim());
        } else {
        // ultra-safe fallback
        this.form.fields.poweroffice_client_key = {
            type: 'text',
            value: String(clientKey).trim(),
        };
        this.form.fields.poweroffice_company_slug = {
            type: 'text',
            value: String(companySlug).trim(),
        };
        this.form.fields.poweroffice_integration_type = {
            type: 'select',
            value: String(integrationType).trim(),
        };
        }

          return true;
        })
        .catch((err) => {
          console.error('[PowerOffice] Failed to load settings:', err);
          this.$message({
            showClose: true,
            message: 'Failed to load PowerOffice settings.',
            customClass: 'error',
          });
        });
    },

    /**
     * Save PowerOffice credentials
     */
    saveSettings() {
      this.loading = true;

      const payload = {
        module_id: this.mod.id,
        poweroffice_client_key: this.form.fields.poweroffice_client_key.value,
        poweroffice_company_slug: this.form.fields.poweroffice_company_slug.value,
        poweroffice_integration_type: this.form.fields.poweroffice_integration_type.value,
      };

      modulesService
        .subscribe(this.mod.id, payload)
        .then(() => {
          this.$message({
            showClose: true,
            message: 'PowerOffice settings updated successfully.',
            type: 'success',
          });

          return Promise.all([
            modulesService.items(),
            organizationSettingsService.show(),
          ]);
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: 'Failed to update PowerOffice settings.',
            customClass: 'error',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeModal() {
      this.toggleModal(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/powerofficeCredentialsModal/powerofficeCredentialsModal.js